import React, { Component } from 'react';
import { upgradeUrl } from '../../common/config';

class StatusCode400 extends Component {
  _onClickDownload = () => {
    window.open(`${upgradeUrl}`);
  }

  render() {
    return (
      <div
        className="modal fade theme-modal qty-modal" id="statusCode400Modal"
        tabIndex="-1" aria-labelledby="statusCode400ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="statusCode400ModalLabel">OPtimize</h5>
              <p>Please upgrade your app version. It&apos;s out of date.</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-12">
                  <button
                    type="button" className="btn btn-link w-100 pt-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
                <hr className="hr-style" />
                <div className="col-12">
                  <button
                    type="button" className="btn btn-link w-100"
                    data-bs-dismiss="modal"
                    onClick={this._onClickDownload}
                  >
                    Get the new version
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StatusCode400;
